/**
 * TODO: Scroll/active anchor tracking.
 */
export const activeAnchor: Record<string, { isActive: boolean }> = {};
